import SVG from "react-inlinesvg";

const SvgComponent = ({ src, fillColor }) => {
  // Define a style object for the SVG fill color
  const svgStyle = {
    fill: fillColor,
  };

  return <SVG src={src} style={svgStyle} />;
};

export default SvgComponent;
